import { render, staticRenderFns } from "./interviewList.vue?vue&type=template&id=35f6dfd3&scoped=true"
import script from "./interviewList.vue?vue&type=script&lang=js"
export * from "./interviewList.vue?vue&type=script&lang=js"
import style0 from "./interviewList.vue?vue&type=style&index=0&id=35f6dfd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f6dfd3",
  null
  
)

export default component.exports